<template>
  <Content id="accountPasswords">
    <div slot="search">
      <Form :label-width="50" :model="search" id="searchForm">
        <Row>
          <Col><FormItem label="机构名称" :label-width="70"><Input v-model="search.name"/></FormItem></Col>
          <Col><div style="display:flex;">&nbsp;&nbsp;<Button type="primary" @click="query">查询</Button></div></Col>
        </Row>
      </Form>

      <div slot="extra" style="margin-bottom: 5px; display: flex;width: 100%" >
        <div style="float: left;">
          <Button size="small" icon="md-add" style="margin-right: 5px;" @click="handleCreate" type="primary">添加</Button>
        </div>
      </div>
    </div>

    <el-table :data="dataList" ref="singleTable" style="width: 100%;" :header-cell-style="{ background:'#f8f8f9',color:'#515a6e','text-align':'center'}"
              :row-class-name="tableRowClassName" @row-click="selectrow" highlight-current-row highlight-selection-row row-key="id" :max-height="tableHeight">

      <el-table-column fixed align="center" prop="name" label="机构名称" min-width="100"/>
      <el-table-column align="center" prop="account" label="账号"/>
      <el-table-column align="center" prop="password" label="密码"/>
      <el-table-column align="center" prop="localAreaUrl" label="局域网路径" min-width="110"/>
      <el-table-column align="center" prop="url" label="映射路径" min-width="110"/>
      <el-table-column align="center" prop="urlType" label="启用路径" min-width="50">
        <template slot-scope="{row}">{{ row.urlType===1?'局域网':row.urlType===2?'映射':''}}</template>
      </el-table-column>
      <el-table-column align="center" prop="operator" label="最后操作人" min-width="150">
        <template #default="{ row }">
          <div>{{ row.operatorAccount }}</div>
          <div>{{ row.operator }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="createTime" label="最后操作时间" min-width="160"/>
      <el-table-column fixed="right" align="center" prop="operation" label="操作"  min-width="80" id="elPopoverVisible">
        <template slot-scope="{row}">
          <el-button type="text" size="medium" @click="handleEdit(row)">编辑</el-button>
          <el-button type="text" size="medium" @click="handleRemove(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <Page :total="pageList.total" :current="pageList.currentPage" :page-size="pageList.pageSize"
          show-elevator show-sizer show-total @on-change="chagecurrent"
          :page-size-opts="[10, 30, 50, 100]" @on-page-size-change="chagepagesize" style="margin-top:10px;"/>

    <Modal ref="modalRef" v-model="editWindow" width="40%" :title="windowTitle" :styles="{'top':'60px'}" :mask-closable="false">
      <AccountPasswordEdit ref="edit"  @on-submit="handleSubmit" />
      <div slot="footer">
        <Button type="primary" @click="submit">确定</Button>
        <Button @click="editWindow = false">取消</Button>
      </div>
    </Modal>

  </Content>
</template>
<script>
import {_delAccountPassword,_getAccountPasswordList} from "@/services/screeningConfig/accountPasswords";
import AccountPasswordEdit from "./AccountPasswordEdit.vue";
export default {
  name: "AccountPasswords",
  components: {AccountPasswordEdit},
  data() {
    return {
      search: {
        name: ""
      },
      dataList: [],
      pageList: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      windowTitle:"新增",
      editWindow:false,
      tableHeight: 0,
      currentRowIndex: null,
    };
  },
  created(){
    this.setDynamicHeight();
    window.addEventListener('resize', this.setDynamicHeight);
  },
  mounted() {
    this.handleDataList();
  },
  methods: {
    setDynamicHeight() {
      const height = window.innerHeight || document.documentElement.clientHeight;
      this.tableHeight = `${height - 300}px`;
    },
    query() {
      this.pageList.currentPage = 1;
      this.handleDataList();
    },
    handleDataList() {
      _getAccountPasswordList({
        ...this.search,
        ...this.pageList,
      }).then(res => {
          if (res.errcode == 1){
            this.dataList = res.data.records;
            this.pageList.total = res.data.total;
          } else {
            this.$message.error(res.errmsg)
          }
        }).catch(() => {});
    },
    handleCreate() {
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }
      this.windowTitle = "新增";
      this.editWindow = true;
      this.$refs["edit"].handleModal();
    },
    handleEdit(row) {
      this.windowTitle = "编辑";
      this.editWindow = true;
      this.$refs["edit"].handleModal(row);
    },
    submit(){
      this.$refs['edit'].handleSubmit();
    },
    handleSubmit(result) {
      if(!result){
        this.editWindow = result;
        this.handleDataList();
      }
    },
    handleRemove(row) {
      setTimeout(() => {
        _delAccountPassword({id: row.id}).then(res => {
            this.$message.success(res.errmsg);
            this.handleDataList();
          }).catch(() => {});
      }, 500);
    },
    tableRowClassName(row, rowIndex) {
      row.row.index = row.rowIndex;
      if (this.currentRowIndex === row.rowIndex) {
        return "select-row";
      }else{
        return "";
      }
    },
    selectrow(e, index, event){
      this.currentRowIndex = e.index;
    },
    chagecurrent(e) {
      this.pageList.currentPage = e
      this.handleDataList()
    },
    chagepagesize(e) {
      this.pageList.pageSize = e
      this.handleDataList()
    },
  }
};
</script>
<style lang="postcss" scoped>
/deep/ .el-table__body tr.select-row>td.el-table__cell{background-color: #beffc5;color: #101010;}
/deep/ #searchForm .ivu-form-item {margin-bottom: 3px;vertical-align: top;zoom: 1;}

</style>
